import { axiosInstance } from "../../../axios/axiosInstance";
import { LANDING_API_URL, getDefaultHeaders } from "../../../config";

const authHeaders = () => {
  const authToken = localStorage.getItem("authToken");
  return {
    ...getDefaultHeaders(),
    Authorization: `Bearer ${authToken}`,
  };
};

export const getCompanyFiles = () =>
  axiosInstance.get(`${LANDING_API_URL}/company-files`, {
    headers: authHeaders(),
  });

export const createCompanyFileRequest = (fileData) =>
  axiosInstance.post(`${LANDING_API_URL}/company-files`, fileData, {
    headers: authHeaders(),
  });

export const updateCompanyFileRequest = (fileId, fileData) =>
  axiosInstance.post(`${LANDING_API_URL}/company-files/${fileId}`, fileData, {
    headers: authHeaders(),
  });

export const removeCompanyFile = (fileId) =>
  axiosInstance.delete(`${LANDING_API_URL}/company-files/${fileId}`, {
    headers: authHeaders(),
  });
